var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelmet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.50004H9.33335C9.20655 7.5002 9.08146 7.5293 8.9676 7.58511C8.85375 7.64093 8.75413 7.72199 8.67633 7.82212C8.59854 7.92226 8.54463 8.03882 8.51869 8.16294C8.49276 8.28707 8.49549 8.41547 8.52669 8.53837C8.94919 10.205 9.85669 11.3867 11.25 12.0834C12.9167 12.9167 14.8609 13.3334 17.0834 13.3334M10 3.33337C11.5509 3.33352 13.0636 3.81446 14.3299 4.70996C15.5961 5.60546 16.5536 6.87148 17.0705 8.33371C17.5874 9.79593 17.6383 11.3824 17.2161 12.8748C16.794 14.3671 15.9196 15.6919 14.7134 16.6667H5.28669C4.08043 15.6919 3.20604 14.3671 2.7839 12.8748C2.36177 11.3824 2.41265 9.79593 2.92955 8.33371C3.44644 6.87148 4.40393 5.60546 5.67017 4.70996C6.93641 3.81446 8.44912 3.33352 10 3.33337Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.ddfd05c2be2bede89701dcf6fab3b3fb.svg";
export { ForwardRef as ReactComponent };